import { lazyLoad } from 'utils/loadable';

export const IngredientPage = lazyLoad(
  () => import('./index'),
  module => module.IngredientPage,
);
